// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import vueResource from 'vue-resource';
import Vuex from 'vuex';
import {
  Autocomplete,
  Button,
  Cascader,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Icon,
  Input,
  InputNumber,
  Loading,
  Option,
  OptionGroup,
  Pagination,
  Popover,
  Popconfirm,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Select,
  Steps,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Tooltip,
  Tree,
  Upload,
  MessageBox,
  Message,
  Menu,
  Submenu,
  MenuItem,
  Collapse,
  CollapseItem,
  Slider,
} from 'element-ui';
import '@/assets/style/ele-theme/index.css';
import '@/assets/style/element-override.css';
import installDirectives from '@/directives/index';
import domain from './scripts/domain';

import App from './App.vue';
import router from './router';
import message from './scripts/ele-message';
import serve from './scripts/serve';
import loading from './components/utils/loading.vue';
import store from './store';
import Msg from './components/msg/msg';
import RbDialog from './components/base/RbDialog.vue';
import RbButton from './modules/exam-report/children/RbButton.vue';
import {
  analyzeSubjectMap,
  analyzeTypeMap,
  questionTypeMap,
  analyzeGradeMap,
} from './scripts/analyzeMap';

Vue.component('rb-dialog', RbDialog);
Vue.component('rb-button', RbButton);
Vue.component(Autocomplete.name, Autocomplete);
Vue.component(Button.name, Button);
Vue.component(Cascader.name, Cascader);
Vue.component(CheckboxButton.name, CheckboxButton);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Checkbox.name, Checkbox);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Dialog.name, Dialog);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(Dropdown.name, Dropdown);
Vue.component(FormItem.name, FormItem);
Vue.component(Form.name, Form);
Vue.component(Icon.name, Icon);
Vue.component(Input.name, Input);
Vue.component(InputNumber.name, InputNumber);
Vue.component('Loading', loading);
Vue.component(Option.name, Option);
Vue.component(OptionGroup.name, OptionGroup);
Vue.component(Pagination.name, Pagination);
Vue.component(Popover.name, Popover);
Vue.component(Popconfirm.name, Popconfirm)
Vue.component(Progress.name, Progress);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Radio.name, Radio);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Select.name, Select);
Vue.component(Steps.name, Steps);
Vue.component(Switch.name, Switch);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Table.name, Table);
Vue.component(TabPane.name, TabPane);
Vue.component(Tabs.name, Tabs);
Vue.component(Tag.name, Tag);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Tree.name, Tree);
Vue.component(Upload.name, Upload);
Vue.component(Menu.name, Menu);
Vue.component(Submenu.name, Submenu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(Collapse.name, Collapse);
Vue.component(CollapseItem.name, CollapseItem);
Vue.component(Slider.name, Slider)

Vue.use(Loading);
Vue.use(vueResource);

// 设置Vue Resource全局超时时间
Vue.http.options.timeout = 300000; // 5分钟超时
Vue.use(Vuex);
Vue.use(Msg);
Vue.use(Loading);
Vue.use(installDirectives);

Vue.prototype.$EleMessageBox = MessageBox;
Vue.prototype.$EleMessage = Message;
Vue.prototype.$serve = serve;
Vue.prototype.$message = message;
Vue.prototype.$bus = new Vue();

const unlessUrls = [
  `${domain['examination-single']['exam-api-domain']}/v1/help_center/video/vote/get`
]

// 不需要 token 的接口列表（登录、注册等）
const noTokenUrls = [
  '/v1/auth/login',
  '/v1/auth/register',
  '/v1/auth/sendPhoneCode',
  '/v1/auth/third_login',
  '/v1/teaching/getSchoolsForSchoolAdmin2'
]

// 统一处理 401 状态码，并全局加 school_id 和 token
Vue.http.interceptors.push((request, next) => {
  const localStoragePrefix = window.localStoragePrefix || ''

  // 检查是否是登录等不需要 token 的接口
  const isNoTokenUrl = noTokenUrls.some(url => request.url.includes(url))

  // 1. 添加token到header（统一使用F_token）
  // 登录接口不需要 token，所以跳过
  if (!isNoTokenUrl) {
    // 优先使用examination_session_token，然后尝试其他可能的key
    const token = localStorage.getItem('examination_session_token')
      || localStorage.getItem(`${localStoragePrefix}session_token`)
      || localStorage.getItem('YUNQUE_EXAMINATION_session_token')
      || localStorage.getItem(`${localStoragePrefix}session_id`)
      || localStorage.getItem('YUNQUE_EXAMINATION_session_id')

    if (token) {
      // 设置请求头，vue-resource使用headers属性
      // 确保headers对象存在并正确初始化
      if (!request.headers) {
        request.headers = {}
      }
      // 直接设置header属性（使用多种方式确保兼容性）
      request.headers.F_token = token
      request.headers.F_token = token
      // 如果headers是Headers对象，也使用set方法
      if (typeof request.headers.set === 'function') {
        try {
          request.headers.set('F_token', token)
        } catch (e) {
          // 如果set方法失败，使用属性方式
          request.headers.F_token = token
        }
      }
    }

    // 添加user_id到header
    const userId = localStorage.getItem('examination_user_id')
      || localStorage.getItem(`${localStoragePrefix}user_id`)
      || localStorage.getItem('YUNQUE_EXAMINATION_user_id')

    if (userId) {
      if (!request.headers) {
        request.headers = {}
      }
      request.headers.user_id = userId
      request.headers.user_id = userId
      if (typeof request.headers.set === 'function') {
        try {
          request.headers.set('user_id', userId)
        } catch (e) {
          request.headers.user_id = userId
        }
      }
    }
  }

  // 2. 获取school_id
  const schoolId = window.localStorage.getItem(`${localStoragePrefix}user_school_id`)
  if (schoolId) {
    // GET请求加到URL参数
    if (request.method === 'GET') {
      const url = new URL(request.url, window.location.origin)
      url.searchParams.set('school_id', schoolId)
      request.url = url.pathname + url.search
    } else if (request.body) {
      // POST/PUT等请求加到body
      if (request.body instanceof FormData) {
        request.body.append('school_id', schoolId)
      } else if (typeof request.body === 'object') {
        request.body.school_id = schoolId
      }
    }
  }

  next(response => {
    if (response.status === 401 && !unlessUrls.includes(request.url)) {
      Vue.prototype.$message.error('登录已过期，请重新登录')
      // 跳转到登录页面
      window.location.href = 'https://www.hhyunyue.com/exam/Login'
    }
  });
});

Vue.filter('subjectIdToText', (v, g) => {
  if (v === 7 && typeof g === 'number' && g >= 10) {
    return '思想政治'
  } if (v === 7 && typeof g === 'number' && g <= 9) {
    return '道德与法治'
  }
  return analyzeSubjectMap[v] || '未知科目'
});
Vue.filter('examTypeIdToText', v => analyzeTypeMap[v] || '未知类型');
Vue.filter('questionTypeIdToText', v => questionTypeMap[v] || '未知题型');
Vue.filter('gradeIdToText', v => (analyzeGradeMap[v] ? analyzeGradeMap[v].name : '未知年级'));

Vue.directive('focus', {
  inserted(el) {
    el.focus();
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
